export default __webpack_public_path__ + "static/media/whirlwind2.f488b7c6.png";